import { permissions } from "../constants";


export const clearCredentials = () => {
  localStorage.removeItem('userCredentials')
  localStorage.removeItem('letterFilters')
  localStorage.removeItem('paymentFilters')
}

export const setCredentials = auth => {
  localStorage.setItem('userCredentials', JSON.stringify(auth))
}

export const getCredentials = () => {
  return JSON.parse(localStorage.getItem('userCredentials'))
}

export const getRoles = () => {
  return Object.keys(permissions);
}

export const hasPermission = (permission) => {
  if(permission) {
    const user = getCredentials();
    const userPermissions = permissions[user.role] || [];
    return !!userPermissions.find(perm => perm === permission)
  }
  return true;
}